var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentBni(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 784.26 784.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#eb6022;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Bank Negara Indonesia (BNI) 46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.02,
    width: 784.26,
    height: 784.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.39,529.37,399,461.91q-21.13-26.37-39.93-53.64C262.4,268.31,205.14,126,246.49,0H0V136Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M447.2,326.09c5.16-44.46,18.75-128.2,100.15-190.38,70.45-53.62,158.72-64,236.91-30.75V0H349.1c-28.69,127.55,46.8,267.79,98.1,326.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M552.75,198.12l-.25.27C470.55,265,490.72,369.38,567,463c58.68,72.24,137.26,123,217.26,84.51V239.22C712.36,165.56,626,138.55,552.75,198.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.02 296.79 0.02 784.16 0.14 784.16 237.44 592.24 0.02 296.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M431.55,500.54c-23.27,19.14-52.09,42.66-84,68.77l30.76,38.39c44.59,55.69,109.87,152.24,190.5,126.13l3.11,3.62-57.38,46.79H784.24V598.77c-138.8,75.49-258.09,6.72-352.69-98.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.35,672,269.43,632.3c-65.53,52.47-134.29,107.64-190,152H381.23C361.69,742.67,326,702.72,301.35,672"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBni);
export default __webpack_public_path__ + "static/media/payment_bni.f0f72d4387ac1ae338d6607194364b74.svg";
export { ForwardRef as ReactComponent };